/**
 * HomeAnnouncement.js — home page announcement linking to a flagged article (admin-controlled, no dismiss)
 */

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './HomeAnnouncement.css';

const HomeAnnouncement = () => {
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const loadAnnouncement = async () => {
      try {
        const response = await fetch('/api/content/home-announcement');
        if (!response.ok || cancelled) return;

        const data = await response.json();
        if (!data?.pageId || cancelled) return;

        setAnnouncement(data);
      } catch (error) {
        console.error('Failed to load home announcement:', error);
      }
    };

    loadAnnouncement();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!announcement) {
    return null;
  }

  return (
    <div className="home-announcement-wrap">
      <Link to={announcement.url} className="home-announcement-box">
        <span className="home-announcement-flag">📢 Announcement</span>
        <strong className="home-announcement-title">{announcement.title}</strong>
        {announcement.description && (
          <p className="home-announcement-description">{announcement.description}</p>
        )}
        <span className="home-announcement-cta">Read article →</span>
      </Link>
    </div>
  );
};

export default HomeAnnouncement;
